export default __webpack_public_path__ + "static/media/Snowflake_3.f2f0f491.svg";